module.exports = __webpack_public_path__ + "static/media/podcast_icon.e4351ea9.svg";